module.exports = __webpack_public_path__ + "static/media/telegramcolored.57afecf0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/blocks/socialButtons/static/img/social/telegramcolored.svg
// module id = 2069
// module chunks = 118